import { createTheme } from '@mui/material/styles';

declare module "@mui/material/styles" {
  interface Palette {
    brand: {
      start: string
      end: string
      gradient: string
      surface: string
      surfaceAlt: string
    }
  }
  interface PaletteOptions {
    brand?: {
      start?: string
      end?: string
      gradient?: string
      surface?: string
      surfaceAlt?: string
    }
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2D7D46',
      light: '#4A9B5F',
      dark: '#1E6B35',
    },
    secondary: {
      main: '#10B981',
      light: '#34D399',
      dark: '#059669',
    },
    background: {
      default: '#FFFFFF',
      paper: '#ffffff',
    },
    brand: {
      start: '#10B981',
      end: '#3B82F6',
      gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
      surface: '#ffffff',
      surfaceAlt: '#F1F5F9',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, system-ui, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
